import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { PhotoAttribution } from '../components/PhotoAttribution';
import type { PhotoAttributionData } from '../components/PhotoAttribution';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

interface GalleryItem {
  id: string;
  slug: string;
  likeCount: number;
  thumbUrl: string;
  attribution: PhotoAttributionData | null;
  liked: boolean;
  theme?: string;
}

export function GalleryPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [items, setItems] = useState<GalleryItem[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    api<{ items: GalleryItem[] }>('/gallery?limit=48')
      .then((data) => setItems(data.items))
      .catch((e) => setError(e.message));
  }, []);

  const playItem = (id: string) => {
    if (!user?.isPremium) {
      navigate('/premium');
      return;
    }
    navigate(`/practice?puzzle=${id}`);
  };

  return (
    <main className="page gallery">
      <h1>{t('gallery.title')}</h1>
      <p className="sub">{t('gallery.sub')}</p>
      {!user?.isPremium && (
        <p className="gallery-hint">
          {t('gallery.premiumHint')} <Link to="/premium">{t('premium.subscribe')}</Link>
        </p>
      )}
      <Link to="/credits" className="link-muted">{t('gallery.credits')}</Link>

      {error && <p className="error">{error}</p>}

      <div className="gallery-grid">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className="gallery-card"
            onClick={() => playItem(item.id)}
          >
            <img src={item.thumbUrl} alt="" loading="lazy" />
            <div className="gallery-card-meta">
              <span className="gallery-likes">♥ {item.likeCount}</span>
              <PhotoAttribution attribution={item.attribution} compact />
            </div>
          </button>
        ))}
      </div>

      <nav className="result-nav">
        <Link to="/">{t('gallery.home')}</Link>
        {user?.isPremium && <Link to="/practice">{t('premium.play')}</Link>}
      </nav>
    </main>
  );
}
